/**
 * جلب الأصناف المفعّلة، مجمّعة حسب الفئة — مصدر واحد لكل الشاشات
 */
import { useQuery } from "@tanstack/react-query";
import api from "../api/client";
import type { Item, ItemCategory } from "../types";

export function useActiveItems() {
  return useQuery({
    queryKey: ["items", "active"],
    staleTime: 5 * 60_000,
    queryFn: () =>
      api.get<{ data: Item[] }>("/items?isActive=true").then((r) => r.data.data),
  });
}

export function useItemCategories(onlyActive = false) {
  return useQuery({
    queryKey: ["item-categories", onlyActive],
    staleTime: 5 * 60_000,
    queryFn: () =>
      api
        .get<{ data: ItemCategory[] }>(`/item-categories${onlyActive ? "?isActive=true" : ""}`)
        .then((r) => r.data.data),
  });
}

/** يجمّع مصفوفة أصناف في أقسام حسب الفئة، محافظاً على الترتيب القادم من الخادم */
export function groupByCategory(items: Item[] = []) {
  const groups: Array<{ id: number; nameAr: string; items: Item[] }> = [];
  const index = new Map<number, number>();
  for (const it of items) {
    const catId   = it.category?.id ?? it.categoryId;
    const catName = it.category?.nameAr ?? "غير مصنّف";
    if (!index.has(catId)) {
      index.set(catId, groups.length);
      groups.push({ id: catId, nameAr: catName, items: [] });
    }
    groups[index.get(catId)!]!.items.push(it);
  }
  return groups;
}
